import React, { useState, useEffect } from "react";
import styles from "./style.module.scss";
import Layout from "../../../components/Layout/authenticatedLayout";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { clearFullViewType } from "../../../state/importsReducer";
import FullImportView from "../../../components/Imports/FullImportView";
import AdminDataManager from "../../../components/DataManagers/AdminDataManager";
import ImportsConsole from "../../../components/Imports/ImportsConsole";
import ImportsDataManager from "../../../components/DataManagers/ImportsDataManager";
import VCarTrace from "../../../components/Imports/vCarTrace";
import EMValues from "../../../components/Imports/EMValues";
import EMFrontiersGraph from "../../../components/Imports/EMFrontiersGraph";
import RacingLineGraph from "../../../components/Imports/RacingLineGraph";
import ImportIDsBar from "../../../components/Imports/ImportIDsBar";
import EMSegmentGraph from "../../../components/Imports/EMSegmentGraph";
import ELapGraph from "../../../components/Imports/eLapGraph";
import {
  EncryptionImport,
  EnergyManagementImport,
  StrategyImport,
} from "../../../types/imports";
import CypherDecoder from "../../../components/Imports/CypherDecoder";

function ImportsPage() {
  const dispatch = useDispatch();

  const fullViewType = useSelector(
    (state: RootState) => state.imports?.fullViewType,
    isEqual,
  );

  const importPreviews = useSelector(
    (state: RootState) => state.imports?.importPreviews,
    isEqual,
  );

  // Capture a snapshot of the import when the modal opens
  const [capturedImport, setCapturedImport] = useState<
    EnergyManagementImport | StrategyImport | EncryptionImport | null
  >(null);

  useEffect(() => {
    if (fullViewType && importPreviews) {
      const importData =
        importPreviews[fullViewType as keyof typeof importPreviews];
      if (importData) {
        setCapturedImport(structuredClone(importData));
      }
    } else {
      setCapturedImport(null);
    }
  }, [fullViewType, importPreviews]);

  return (
    <Layout title={"Imports"} showJaguarLogo={false}>
      <AdminDataManager />
      <ImportsDataManager />
      <div className={styles.container}>
        <ImportsConsole />
        <div className={styles.previewWidgets}>
          <div className={styles.emWidgetRow}>
            <EMValues />
            <EMFrontiersGraph />
            <EMSegmentGraph />
          </div>
          <div className={styles.strategyWidgetRow}>
            <VCarTrace />
            <RacingLineGraph />
            <ELapGraph />
          </div>
          <div className={styles.encryptionWidgetRow}>
            {/* <EncryptionCodeTable type="short" />
            <EncryptionCodeTable type="long" /> */}
            <CypherDecoder type="green" />
            <CypherDecoder type="orange" />
          </div>
          <ImportIDsBar />
        </div>
        {fullViewType && capturedImport && (
          <FullImportView
            import={capturedImport}
            onClose={() => dispatch(clearFullViewType())}
          />
        )}
      </div>
    </Layout>
  );
}

export default ImportsPage;
